// Module: calendar — «التقويم» (HANDOFF-erp-web §3 / §5.1): day (staff columns
// or one lane), week (Saturday first) and month, `?view=day|week|month&date=`.

import { CalendarDays } from 'lucide-react';
import { defineModule } from '@/app/module-types';

export default defineModule({
  key: 'calendar',
  label: 'المواعيد',
  icon: CalendarDays,
  flag: 'erp.core',
  minRole: 'staff',
  rail: 'appointments',
  routes: [{ path: '/calendar', lazy: () => import('./screens/Calendar').then((m) => ({ Component: m.default })) }],
  menu: [{ key: 'calendar', label: 'التقويم', to: '/calendar' }],
});
